import { CircularProgress, Stack } from '@mui/material';

export default function SoloLoading() {
  return (
    <Stack alignItems="center" sx={{ p: 8 }}>
      <CircularProgress />
    </Stack>
  );
}
